/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { FaGithub, FaTwitter, FaLinkedin } from 'react-icons/fa';
import type { FC } from 'react';

import ContactLink from './contact-link';
import { useSiteMetadata } from './hooks/use-site-metadata';
import { rhythm } from './styles/typography';

const ContactLinks: FC = () => {
  const siteMetadata = useSiteMetadata();

  return (
    <div
      css={css`
        display: flex;
        justify-content: center;
        margin: ${rhythm(1)} 0 0;

        svg {
          vertical-align: middle;
        }

        a:last-of-type {
          margin-right: 0;
        }

        @media screen and (min-width: 60em) {
          & {
            margin: 0;
            justify-content: flex-start;
          }
        }
      `}
    >
      <ContactLink href={`//github.com/${siteMetadata.social.github}`} label="Github">
        <FaGithub />
      </ContactLink>

      <ContactLink href={`//twitter.com/${siteMetadata.social.twitter}`} label="Twitter">
        <FaTwitter />
      </ContactLink>

      <ContactLink href={`//www.linkedin.com/in/${siteMetadata.social.linkedin}`} label="LinkedIn">
        <FaLinkedin />
      </ContactLink>
    </div>
  );
};

export default ContactLinks;
